module.exports = __webpack_public_path__ + "static/media/cover.3abf41d.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/4/cover.webm
// module id = BIcD
// module chunks = 0